import { storageKeys } from 'config/app.config';

export class TokenService {
  static getAccessToken(): string | null {
    return localStorage.getItem(storageKeys.accessToken);
  }

  static saveAccessToken(token: string): void {
    localStorage.setItem(storageKeys.accessToken, token);
  }

  static clear(): void {
    localStorage.removeItem(storageKeys.accessToken);
  }
}
